export const paths = {
    blog: '/blog',
    blogTag: '/blog/tag',
};
